import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {redo, undo} from '@Components/poster-editor/library/poster-editor-library';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {useAppSelector} from '@/hooks';
import styles from './nav-undo-redo-options.module.scss';
import {useShowContextualSkeletons} from '@Hooks/poster-editor/useShowContextualSkeletons';

export function NavUndoRedoOptions(): ReactElement<any> | null {
  const hasUndo = useAppSelector((state) => {
    return state.posterEditor.hasUndo;
  });
  const hasRedo = useAppSelector((state) => {
    return state.posterEditor.hasRedo;
  });
  const showSkeletons = useShowContextualSkeletons();

  return showSkeletons ? (
    <>
      <div className={styles.skeletonContainer}>
        <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={20} height={20} />
      </div>
      <div className={styles.skeletonContainer}>
        <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={20} height={20} />
      </div>
    </>
  ) : (
    <div className="js-undo-redo-options">
      <Icon
        onClick={undo}
        isDisabled={!hasUndo}
        icon="icon-rotate-ccw"
        size={IconSize.SIZE_ICON_20}
        className="spacing-m-r-2 js-undo-btn"
        shape={IconShape.SQUARE}
        type={IconType.DARK_GHOST}
      />
      <Icon onClick={redo} isDisabled={!hasRedo} icon="icon-rotate-cw" size={IconSize.SIZE_ICON_20} className="js-redo-btn" shape={IconShape.SQUARE} type={IconType.DARK_GHOST} />
    </div>
  );
}
